import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const q = new URLSearchParams(window.location.search).get('lang');
    if (q === 'en' || q === 'bn') localStorage.setItem('ndp_lang', q);
    return localStorage.getItem('ndp_lang') || 'en';
  });

  const toggleLanguage = () => {
    setLanguage(prev => {
      const next = prev === 'en' ? 'bn' : 'en';
      localStorage.setItem('ndp_lang', next);
      return next;
    });
  };

  const t = (textObj) => {
    if (typeof textObj === 'string') return textObj;
    return textObj[language] || textObj.en || '';
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};